import {useTranslation} from 'react-i18next';
import {CtaDock, Skeleton, cn} from '@chekinapp/ui';
import {
  COUNTER_FORM_DOCK_CLASS,
  COUNTER_GROUP_CLASS,
  COUNTER_GROUPED_ROW_CLASS,
} from '@chekin/shared/guest-form';
import {StepHeading} from 'pages/InstantCheckIn/steps/StepParts';

const COUNTER_ROWS = 2;
const NEXT_STEPS = 2;

function FoundGuestCountSkeleton() {
  const {t} = useTranslation();

  return (
    <div aria-busy="true">
      <StepHeading lead={t('guest_count_check_lead')}>
        {t('instant_check_in.confirm_whos_coming')}
      </StepHeading>

      <div aria-hidden="true">
        <div className={COUNTER_GROUP_CLASS}>
          {Array.from({length: COUNTER_ROWS}, (_, index) => (
            <div
              key={index}
              className={cn(COUNTER_GROUPED_ROW_CLASS, 'flex items-center gap-3')}
            >
              <div className="flex-1">
                <Skeleton className="h-4 w-24 rounded-md" />
                <Skeleton className="mt-2 h-3 w-32 rounded-md" />
              </div>
              <Skeleton className="size-11 shrink-0 rounded-[14px] desk:size-9" />
              <Skeleton className="size-11 shrink-0 rounded-[14px] desk:size-9" />
            </div>
          ))}
        </div>

        <div data-guest-count-note className="mt-3 px-0.5">
          <Skeleton className="h-3 w-full rounded-md" />
          <Skeleton className="mt-2 h-3 w-2/3 rounded-md" />
        </div>

        <div data-guest-count-next className="pt-[18px]">
          <Skeleton className="mb-3 h-3 w-36 rounded-md" />
          <div className="flex flex-col gap-3">
            {Array.from({length: NEXT_STEPS}, (_, index) => (
              <div key={index} className="flex items-center gap-3">
                <Skeleton className="size-[34px] shrink-0 rounded-[11px]" />
                <div className="flex-1">
                  <Skeleton className="h-3.5 w-40 rounded-md" />
                  <Skeleton
                    data-guest-count-hint
                    className="mt-2 h-3 w-52 max-w-full rounded-md"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        <CtaDock elevated className={COUNTER_FORM_DOCK_CLASS}>
          <Skeleton className="h-12 w-full rounded-[var(--button-radius)]" />
        </CtaDock>
      </div>
    </div>
  );
}

export {FoundGuestCountSkeleton};
